import { cn } from "@/lib/utils.ts";

/** The digit 3, drawn as a stroke so the mark looks the same before and after the fonts load. */
const THREE = "M0.2 1.7C0.7 0.6 1.7 0 3 0C4.7 0 5.8 1 5.8 2.5C5.8 4 4.6 4.9 2.9 4.9C4.8 4.9 6.1 6 6.1 7.6C6.1 9.3 4.8 10.4 3 10.4C1.6 10.4 0.5 9.8 0 8.7";

/**
 * The Box 33 mark: a square stamp outline (rounded corners, 2px stroke) with a bold "33".
 * Uses `currentColor`; `accent` paints the digits stamp red.
 */
export function Logo({
  size = 28,
  accent = false,
  title,
  className,
}: {
  size?: number;
  accent?: boolean;
  title?: string;
  className?: string;
}) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 32 32"
      fill="none"
      className={cn("shrink-0", className)}
      role={title ? "img" : undefined}
      aria-hidden={title ? undefined : true}
    >
      {title ? <title>{title}</title> : null}
      <rect x="3" y="3" width="26" height="26" rx="6" stroke="currentColor" strokeWidth="2" vectorEffect="non-scaling-stroke" />
      <g
        stroke={accent ? "var(--stamp-bright)" : "currentColor"}
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d={THREE} transform="translate(8.85 10.8)" />
        <path d={THREE} transform="translate(17.05 10.8)" />
      </g>
    </svg>
  );
}

/** Logo and product name, as in the sidebar. */
export function Wordmark({ name, className, size = 26 }: { name: string; className?: string; size?: number }) {
  return (
    <span className={cn("inline-flex items-center gap-2.5", className)}>
      <Logo size={size} className="text-primary dark:text-foreground" />
      <span className="text-[15px] font-bold tracking-[-0.015em] text-foreground">{name}</span>
    </span>
  );
}
